module.exports = __webpack_public_path__ + "static/media/05_Eurojust_tribunal_dela_Haye.7223deb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_tribunal-la-haye/05_Eurojust_tribunal_dela_Haye.jpg
// module id = 1172
// module chunks = 37